var map = {
	"./cyfrowe-sp-z-o-o/Loader": [
		"2260",
		"chunk-9757d206"
	],
	"./iai/Loader": [
		"462f",
		"chunk-386d0655"
	],
	"./njumobile/Loader": [
		"1182",
		"chunk-80f5959c"
	],
	"./njumobileweb/Loader": [
		"57f1",
		"chunk-59bb55ba"
	],
	"./orangedoppayment/Loader": [
		"cb69",
		"chunk-9d8e62ee"
	],
	"./paynow/Loader": [
		"5f6a",
		"chunk-0fc1d8ae"
	],
	"./planetpay/Loader": [
		"a587",
		"chunk-799fac72"
	],
	"./polcard/Loader": [
		"d71d",
		"chunk-00e3ef09"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8ad7";
module.exports = webpackAsyncContext;